import { useEffect, useState } from 'react';
import InputAHSF from '../../Components/InputAHSF';
import './style.css'
import { AddObjectiveProjects, GetOneRecordObjectiveProjectsList, UpdataObjectiveProjects } from '../../Redux/Reducers/ReportStage/Objective';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setRefreshTable } from '../../Redux/Reducers/VariousVariables';
import Swal from 'sweetalert2'
import $ from "jquery";
const AddObjectivesProject = (props) => {
    const dispatch = useDispatch()
    const addObjectivess = useSelector((state) => state.ObjectiveReducer.addObjective)
    const reports = useSelector((state) => state.ReportByAppGuidReducers.ReportByApp)
    const Objective_ = useSelector((state) => state.ObjectiveReducer.Objective)
    const [Objectives, setObjectives] = useState(null)
    const [validationStatus, setValidationStatus] = useState(false)
    const addObjectives = () => {
        if (Objectives == null) {
            setValidationStatus(true)
        } else {
            setValidationStatus(true)
            dispatch(AddObjectiveProjects({ objectiveName: Objectives, pR_ReportsId: reports?.pR_ReportsId }))
            $(".close-btn").trigger("click"); // Simulate click to close modal

            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم اضافة المعلومات بنجاح", // Success message in Arabic
                showConfirmButton: false,
                timer: 1500, // Auto-close after 1.5 seconds
            });
        }

    }


    const editObjectives = () => {
        if (Objectives == null) {
            setValidationStatus(true)
        } else {
            dispatch(UpdataObjectiveProjects({ pR_ObjectiveProjectsId: props.objectiveProjectsId, objectiveName: Objectives, pR_ReportsId: reports?.pR_ReportsId }))
            $(".close-btn").trigger("click"); // Simulate click to close modal

            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم اضافة المعلومات بنجاح", // Success message in Arabic
                showConfirmButton: false,
                timer: 1500, // Auto-close after 1.5 seconds
            });
        }

    }


    useEffect(() => {
        if (props.statusAction == "edit") {
            dispatch(GetOneRecordObjectiveProjectsList({ pR_ObjectiveProjectsId: props.objectiveProjectsId }))
        }
    }, [props.objectiveProjectsId])






    return (
        <div className='containerObjectivesRs'>
            <div>
                {
                    Objective_ ? <InputAHSF
                        fieldsName="ExObjectives"
                        show={true}
                        disabled={false}
                        comma={false}
                        onChange={(e) => {
                            setObjectives(e.target.value)
                        }}
                        defaultValue={props.statusAction == "edit" ? Objective_?.objectiveName : ""}
                        showValidationMessage={
                            validationStatus
                        }
                        validationMessage="يرجى تعبئة هذا الحقل"
                    /> : <></>
                }
            </div>


            <div className='containerButton'>
                {
                    props.statusAction == "edit" ?
                        <button className="custom-button" onClick={editObjectives}>
                            تعديل
                        </button>
                        : <button className="custom-button" onClick={addObjectives}>
                            حفظ
                        </button>
                }


            </div>
        </div>
    )
}

export default AddObjectivesProject